import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

type Props = {
  benefits: string[]
}

const BenefitsList = ({ benefits }: Props) => {
  return (
    <>
      {benefits.map((benefit) => (
        <Box
          key={benefit}
          flexDirection="row"
          paddingTop="s8"
          gap="s8"
          alignItems="center"
          style={{ wordBreak: 'break-word' }}
        >
          <Icon.Small icon="check" encircled="viridian1000" color="grey000White" />
          <Text.Normal>{benefit}</Text.Normal>
        </Box>
      ))}
    </>
  )
}

export default BenefitsList
